import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { VulnerabilityPolicyInput } from '../'
import { logSuccess, logError } from '../../toaster'

export const createVulnerabilityPolicyMutation = gql`
  mutation createVulnerabilityPolicy(
    $organizationID: ID!
    $policy: VulnerabilityPolicyInput!
  ) {
    createVulnerabilityPolicy(
      input: { organizationID: $organizationID, policy: $policy }
    ) {
      _placeholder
    }
  }
`

export interface CreateVulnerabilityPolicyArgs {
  readonly organizationID: string
  readonly policy: Partial<VulnerabilityPolicyInput>
}

export function CreateVulnerabilityPolicyMutation({
  children
}: {
  readonly children: (
    createVulnerabilityPolicy: (
      variables: CreateVulnerabilityPolicyArgs,
      successMessage: string,
      errorMessage: string
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, CreateVulnerabilityPolicyArgs>
      mutation={createVulnerabilityPolicyMutation}
    >
      {(createVulnerabilityPolicy) => {
        return children(
          async (
            variables: CreateVulnerabilityPolicyArgs,
            successMessage,
            errorMessage
          ) => {
            try {
              const response = await createVulnerabilityPolicy({
                variables
              })

              if (response?.errors) {
                logError(errorMessage)
                return
              }
              logSuccess(successMessage)
            } catch (_) {
              logError(errorMessage)
            }
          }
        )
      }}
    </Mutation>
  )
}
